import React, { useEffect, useRef, useState } from 'react'
import { Chart, PieController, ArcElement, Legend, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import CustomModal from '../../../../Components/Modals/CustomModal';

Chart.register(PieController, ChartDataLabels, ArcElement, Legend, Tooltip);

function PieChart(props) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const isCompact = !!props.compact;
  const canOpenPopup = props.openInPopup !== false && isCompact;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const labels = props.Status ? props.Status : [];
  const counts = props.count ? props.count : [];
  const colors = props.color ? props.color : [];
  const labelsKey = JSON.stringify(labels);
  const countsKey = JSON.stringify(counts);
  const colorsKey = JSON.stringify(colors);

  const chartData = {
    labels: labels,
    datasets: [
      {
        data: counts,
        backgroundColor: colors,
        borderWidth: 0.5,
        borderColor: 'black',
      },
    ],
  };

  useEffect(() => {
    if (!chartRef.current) {
      return;
    }

    const pieChartContext = chartRef.current.getContext('2d');

    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    chartInstance.current = new Chart(pieChartContext, {
      type: 'pie',
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: isCompact ? 'right' : 'top',
            labels: {
              boxWidth: isCompact ? 8 : 10,
              boxHeight: isCompact ? 8 : 10,
              font: {
                size: isCompact ? 9 : 11,
              },
            },
          },
          datalabels: {
            color: 'black',
            font: {
              size: isCompact ? 10 : 12,
              weight: 'bold',
            },
            formatter: (value) => (value > 0 ? value : ''),
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [labelsKey, countsKey, colorsKey, isCompact]);

  return (
    <>
      <div
        onClick={canOpenPopup ? () => setIsPopupOpen(true) : undefined}
        title={canOpenPopup ? 'Click to enlarge' : undefined}
        style={{
          height: props.height || (isCompact ? '90px' : '220px'),
          width: props.width || '100%',
          position: 'relative',
          cursor: canOpenPopup ? 'pointer' : 'default',
        }}
      >
        <canvas ref={chartRef} />
      </div>

      {canOpenPopup && (
        <CustomModal
          isOpen={isPopupOpen}
          toggle={() => setIsPopupOpen(false)}
          size="md"
          header={props.popupTitle || 'Status Overview'}
          className="curve-popup"
        >
          <div className="d-flex justify-content-center p-2">
            <PieChart
              openInPopup={false}
              height="320px"
              width="100%"
              Status={labels}
              count={counts}
              color={colors}
            />
          </div>
        </CustomModal>
      )}
    </>
  );
}

export default PieChart
